module.exports = __webpack_public_path__ + "static/media/workingmemory-words-7.e7641ab5.mp3";